import SendIcon from '@mui/icons-material/Send'
import { Box, IconButton, TextField } from '@mui/material'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'

export default function MessageInput(
  { onSend, pending, disabled = false, placeholder }:
  {
    onSend: (text: string) => boolean | void
    pending: boolean
    disabled?: boolean
    placeholder?: string
  },
) {
  const intl = useIntl()
  const resolvedPlaceholder = placeholder ?? intl.formatMessage({ id: 'caChat.input.placeholder' })
  const [value, setValue] = useState('')
  const blocked = pending || disabled
  const send = () => {
    const text = value.trim()
    if (!text || blocked) { return }
    if (onSend(text) === false) { return }
    setValue('')
  }
  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    send()
  }
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey && !(e.nativeEvent as { isComposing?: boolean }).isComposing) {
      e.preventDefault()
      send()
    }
  }
  return (
    <Box component="form" onSubmit={submit} sx={{ display: 'flex', alignItems: 'flex-end', gap: 1, p: 1 }}>
      <TextField
        fullWidth={true} size="small" placeholder={resolvedPlaceholder}
        multiline={true} maxRows={6}
        value={value} disabled={blocked}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <IconButton type="submit" color="primary" disabled={blocked}><SendIcon /></IconButton>
    </Box>
  )
}
